module.exports = __webpack_public_path__ + "static/media/approved.3d9a7a6a.svg";